<div *ngIf="isLoading | async" class="app-spinner">
  <mat-progress-spinner mode="indeterminate" [diameter]="200"></mat-progress-spinner>
</div>
